// @flow
import type { Node } from 'react';
import React from 'react';
import './PageTemplate.scss';

type Props = {
  children: Node,
};

const PageTemplate = ({ children }: Props) => {
  return (
    <div className="PageTemplate">
      <div className="main">{children}</div>
    </div>
  );
};

export default PageTemplate;



// WEBPACK FOOTER //
// ./src/components/base/PageTemplate/PageTemplate.js